import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import crypto from "crypto-js";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit {

  @Output() register: EventEmitter<any> = new EventEmitter();
  @Output() gotoLoginTab: EventEmitter<any> = new EventEmitter();
  passwordConditions: string = `
    - Password must be at least 8 characters long.
    - Must contain at least one uppercase letter.
    - Must contain at least one lowercase letter.
    - Must contain at least one number.
    - Must contain at least one special character.
  `;
  showPassword = false;

  constructor(private fb: FormBuilder) { }

  registerForm = this.fb.group({
    name: ['', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(100),
      RegisterComponent.companyNameValidator()
    ]],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    address: ['', [
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(200),
      RegisterComponent.addressValidator()
    ]]
  });

  ngOnInit() { }

  onRegister() {
    // Normalize name before submit
    if (this.registerForm.value?.name) {
      this.registerForm.patchValue({ name: String(this.registerForm.value.name).replace(/\s+/g, ' ').trim() });
    }
    const password = crypto.AES.encrypt(this.registerForm.value.password, "evaltrixSecret").toString();
    const email = this.registerForm.value.email.toLowerCase();
    this.register.emit({
      ...this.registerForm.value,
      email,
      password,
    });
  }

  gotoLogin(): void {
    // Clear form to avoid leaving sensitive data in memory/DOM
    this.registerForm.reset();
    this.gotoLoginTab.emit();
  }

}

// Static validator reused with same rules as branding company name
export namespace RegisterComponent {
  export function companyNameValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const raw = (control?.value ?? '').toString();
      const value = raw.trim();
      if (!raw || /^\s*$/.test(raw)) { return { whitespace: true } as any; }
      if (value.length < 2) { return { minlengthStrict: true } as any; }
      if (/^\d+$/.test(value)) { return { digitsOnly: true } as any; }
      if (!/[A-Za-z]/.test(value)) { return { alphaRequired: true } as any; }
      if (/\s{2,}/.test(value)) { return { multiSpace: true } as any; }
      if (!/^[A-Za-z0-9 .,&'\-()]+$/.test(value)) { return { invalidChars: true } as any; }
      return null;
    };
  }

  // Address validation: prevent only spaces or only numbers, allow common characters
  export function addressValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const raw = (control?.value ?? '').toString();
      const value = raw.trim();

      if (!raw || /^\s*$/.test(raw)) { return { whitespace: true } as any; }
      if (value.length < 5) { return { minlengthStrict: true } as any; }
      if (/^\d+$/.test(value)) { return { digitsOnly: true } as any; }
      // Allow letters, numbers, spaces, new lines and common address punctuation (including ;) 
      if (!/^[A-Za-z0-9 .,#'\-\/();\n\r]+$/.test(value)) { return { invalidChars: true } as any; }
      return null;
    };
  }
}
